import { Button, Grid, Typography } from "@mui/material";
import { IError } from "itsf-ui-common";
import { useTranslation } from "react-i18next";

interface IGenericErrorProps {
    error: IError;
    isHomePage?: boolean;
    retryFetch?(): void;
}

export const Error = (props: IGenericErrorProps) => {
    const {
        error: { errorMessage, status },
        isHomePage,
        retryFetch,
    } = props;
    const { t } = useTranslation("common");

    const is404 = status === 404;
    const canRetry = Boolean(retryFetch);

    const errorIcon = isHomePage ? require("@static/img/error/error-home.png") : require("@static/img/error/error.png");

    return (
        <Grid alignItems="center" container direction="column" justifyContent="center">
            <Grid
                item
                style={{ flex: "1 1 auto", display: "flex", flexDirection: "column", alignItems: "center" }}
                xs={12}
            >
                <img alt="error icon" src={errorIcon} style={{ height: "50px", width: "50px" }} />
                <Typography color="inherit" variant="h6">
                    {is404 ? "404 not found" : "Oops..."}
                </Typography>
                <Typography align="center" color="inherit">
                    {errorMessage ? errorMessage : t("genericError")}
                </Typography>
            </Grid>
            {canRetry && (
                <Grid item style={{ flex: "1 1 auto", marginTop: 20 }} xs={12}>
                    <Button color="inherit" type="submit" variant="outlined" onClick={retryFetch}>
                        {t("retry")}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};
